
import axios from "../api/axiosInstance";

export const getOpenOrders = (params = {}) =>
  axios.get("/OpenOrders/GetOrdersList", { params });


export const getOpenOrderItems = (orderRef) =>
  axios.get(`/OpenOrders/GetOpenOrderItems?orderRef=${orderRef}`);

